import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  max-width: 360px;

  .icon-container {
    height: 25px;
    width: 25px;
    margin-right: 8px;
  }

  .display-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .account-separator-icon {
    flex: 0 0 28px
  }

  .circular-progress {
    padding-top: 30px;
  }

  .account-separator {
    padding: 0 20px;
    min-height: 28px;
  }
`;

export const AccountWidgetCircle = styled.div(({ theme }) => css`
  position: relative;
  display: flex;
  justify-content: stretch;
  align-items: stretch;

  .outer-circle {
    display: block;
    position: absolute;
    top: 0;
    border-radius: 50%;
    border: 2px solid #a6a6a6;

    /* perfect square with variable width */
    width: 100%;
    box-sizing: border-box;

    &:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }

    /* END perfect square with variable width */

    &.red-border {
      border-color: ${theme.palette.status.bad};
    }
  }

  .inner-circle {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .bold-green { // leave
    color: ${theme.palette.status.good};
    font-weight: ${theme.fonts.headingWeight};
  }

  .bold-red { // leave
    font-weight: ${theme.fonts.headingWeight};
    color: ${theme.palette.status.bad};
  }

  .separator { // leave
    width: 230px;
    border-top: 1px solid ${theme.palette.status.good};
  }

  .hide-desktop {
    @media only screen and (min-width: ${theme.breakpoints.M}) {
      display: none;
    }
  }

  .account-type { // leave
    position: absolute;
    top: 4%;
    right: 8%;
    border-radius: 40px;
    height: 45px;
    width: 45px;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: ${theme.fonts.headingWeight};
    font-size: 12px;
    color: ${theme.palette.grayscale.darkGray};
    text-transform: ${theme.fonts.headingCase};
    text-align: center;
    line-height: 12px;
    padding: 3px 2px 3px 2px;

    &.red {
      color: ${theme.palette.status.bad};
      background-color: ${theme.palette.main.white};
    }
  }

  .light-green { // leave
    color: ${theme.palette.status.good};
  }

  .mtn-5 { // leave
    margin-top: -8px;
  }
`);
